export default "__VITE_ASSET__q8$R74pT__"